module.exports = __webpack_public_path__ + "media/images/question-3fd8ad1ed35e330dd100fff58d97bd05a2e0af0492f8ade954ff3d450e9ac997.svg";